<template>
  <div class="container mb-2 card_box">
    <div class="row">     
      <div class="col-md-8 m-auto">
        <div class="input-group">
          <label for="Search" class="d-none">Search</label>
          <input
            v-show="hasEvent"
            v-model="text_search_event"
            id="Search"
            type="text"
            class="form-control et-gf-search"
            placeholder="Search"
            @keyup="searchTextChanged"
          >
          <span class="input-group-btn">
            <button
              v-show="hasEvent"
              class="btn btn-search rounded-0"
              type="button"
            >
              <span class="d-none">Search</span>
            </button>
          </span>
        </div>
        <span
          v-if="LoadingSearch"
          class="image_loading_search"
        >
          <img src="https://www.gofundraise.com.au/Content/images/loader-orange.gif" />
        </span>
        <div
          v-if="ValueEnterSearch"
          v-click-outside="hideAutoCompleteSearchResults"
          class="search_result"
        >
          <ul class="list-unstyled">
            <template v-for="(item, index) in eventsList" :key="index">
              <li
                v-if="index < 3"
                @click="$_eventManagementMixin_searchEventByName(item.EventName)"
              >
                {{ item.EventName }}
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
    <div class="row text-center content-team mt-3">
      <EventTypeTabs
        v-show="showTab"
        default-selected-tab="occasion"
        @eventTypeSelection="$_eventManagementMixin_eventTypeChanged"
      />

      <!-- Internal Events -->      
      <div
        v-show="data_event_internal.length > 0 && ((text_search_event === '' && eventTypeSelected === 'occasion') || $_eventManagementMixin_selectedEventIsInternal())"
        :class="['row w-100 m-auto']"
      >
        <EventList
          :items="eventsListInternal"
          list-identifier="internalEvents"
        />
      </div>

      <!-- External Events -->
      <div
        v-show="data_event.length > 0 && (text_search_event != '' || eventTypeSelected === 'event')"
        :class="['row w-100 m-auto']"
      >
        <EventList
          :items="eventsList"
          list-identifier="externalEvents"
        />
      </div>

      <div class="row w-100">
        <div
          v-show="LazyLoading"
          class="lazy-load"
        >
          <img src="https://www.gofundraise.com.au/Content/images/loader-orange.gif" />
        </div>
        <div id="scroll-loader-ev"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ClickOutside from '@mahdikhashan/vue3-click-outside'
import EventList from './EventList.vue'
import EventTypeTabs from './EventTypeTabs.vue'
import store from '../../store/store'
import useEmitter from '../../composables/useEmitter'

export default {
  name: 'EventManagementMixin',
  components: { EventList, EventTypeTabs },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      ValueEnterSearch: false,
      LazyLoading: false,
      LoadingSearch: false,
      eventcampaignid: '',
      eventTypeSelected: '',
      selectedEventType: '',
      internalEventsPageNumber: 1,
      customEventsPageNumber: 1,
      customEventSearchTotalPages: 1,
      text_search_event: '',
      data_event: [],
      data_event_internal: [],
      store,
    }
  },
  computed: {
    showTab: {
      get() {
        return this.text_search_event === '' && this.hasEvent
      },
    },
    hasEvent : {
      get() {
        return this.store.state.selected_event 
        && this.store.state.selected_event !== ''
        && this.store.state.selected_event.EventCampaignId !== ''
      },
    },
    eventsList: {
      get() {
        return this.data_event
      },
      set(value) {
        var vm = this
        if (value != null) {
          this.data_event = this.data_event.concat(value)
        }
      },
    },
    eventsListInternal: {
      get() {
        return this.data_event_internal
      },
      set(value) {
        if (value != null) {
          this.data_event_internal = this.data_event_internal.concat(value)
        }
      }
    }
  },

  watch: {
    text_search_event(res) {
      if (res === '') {
        this.searchTextChanged()
      }
    }
  },

  created() {
    var self = this
    this.LazyLoading = true
    this.text_search_event = this.store.state.res_text_search_event
    
    let params_query = {
      params: {
        query: this.text_search_event,
        region: this.store.state.region,
        beneficiaryaccountid: this.store.state.selected_charity.beneficiaryId
      }
    }

    this.$_eventManagementMixin_internalEventSearch(params_query)
      .then(response => {
        self.internalEventsPageNumber = response.data.PageNumber + 1
        self.data_event_internal = response.data.Events
      })
      .then(() => {
        self.LazyLoading = false
        self.ValueEnterSearch = false
        self.$_eventManagementMixin_scrollLoadMoreData('#scroll-loader-ev')
        self.$_eventManagementMixin_customEventSearch()
      })

    useEmitter().emitter().on('stageEvent', self.stage)
    useEmitter().emitter().on('stageEvent', self.$_eventManagementMixin_setEventName)
    useEmitter().emitter().on('clearEvent', self.$_eventManagementMixin_clearEvent)
  },

  methods: {
    hideAutoCompleteSearchResults() {
      this.ValueEnterSearch = false
    },

    $_eventManagementMixin_selectedEventIsInternal() {            
      var vm = this
      var found = false
      if (this.store.state.selected_event && this.store.state.selected_event !== '') {
        found = this.data_event_internal.find(function(element) {
          return element.EventCampaignId === vm.store.state.selected_event.EventCampaignId
        })
      }
      return found
    },

    $_eventManagementMixin_eventTypeChanged(eventType) {
      this.eventTypeSelected = eventType
    },

    $_eventManagementMixin_setEventName(param) {
      this.store.commit('res_text_search_event', param.eventName || '')
      this.selectedEventType = "internal"
    },

    $_eventManagementMixin_clearEvent() { 
      this.store.commit('change_event', '')
      this.store.commit('res_text_search_event', '')
      this.text_search_event = ''
    },

    async $_eventManagementMixin_eventSearch(params_query) {
      return await axios.get(this.store.state.apiDomain + '/v1/events/search', params_query)
    },

    async $_eventManagementMixin_internalEventSearch(params_query) {
      params_query.params["eventtype"] = 'I'
      return this.$_eventManagementMixin_eventSearch(params_query)
    },

    $_eventManagementMixin_customEventSearch() {
      var self = this
      if (!self.LazyLoading) {
        self.LazyLoading = true
        let params_query = {
          params: {
            query: self.text_search_event,
            excludeeventswithrestrictedpagecreation: true,
            region: self.store.state.region,
            pageindex: self.customEventsPageNumber,
            eventtype: "C",
            beneficiaryaccountid: self.store.state.selected_charity.beneficiaryId
          }
        }
        
        if (self.customEventsPageNumber > self.customEventSearchTotalPages) {
          self.LazyLoading = false
          return
        }
        
        self.$_eventManagementMixin_eventSearch(params_query)
          .then(response => {
            if (!response)
              return

            self.customEventsPageNumber = response.data.PageNumber + 1
            self.eventsList = response.data.Events
            self.customEventSearchTotalPages = response.data.TotalPages

          }).then(() => {
            self.LazyLoading = false
          })
      }
    },

    $_eventManagementMixin_scrollLoadMoreData(scrollDivSelector) {
      var self = this
      window.addEventListener("scroll", function() {
        var scrollDiv = document.querySelector(scrollDivSelector)
        if (scrollDiv) {
          var hT = scrollDiv.offsetTop
          var hH = scrollDiv.offsetHeight
          var wH = window.innerHeight
          var wS = window.scrollY

          if (wS > hT + hH - wH) {
            if (self.eventTypeSelected === 'event') {
              self.$_eventManagementMixin_customEventSearch()
            }
          }
        }
      })
    },

    $_eventManagementMixin_searchEventByName(name) {
      var self = this;
      let params_query = {
        params:{
          query: name,
          excludeeventswithrestrictedpagecreation: true,
          region: self.store.state.region
        }
      }
  
      this.$_eventManagementMixin_eventSearch(params_query)
        .then(response => {
          self.text_search_event = response.data.Events[0].EventName
          self.data_event = response.data.Events
        }).then(() => {
          self.ValueEnterSearch = false
        })
    },

    searchTextChanged() {
      var res = this.text_search_event
      var vm = this
      vm.LoadingSearch = false
      vm.ValueEnterSearch = res !== ''
      this.$_eventManagementMixin_internalEventSearch({
        params: {
          region: this.store.state.region,
          beneficiaryaccountid: this.store.state.selected_charity.beneficiaryId,
          query: res
        }
      }).then(response => {
        vm.data_event_internal = response.data.Events
      });

      let params_query = {
        params: {
          query: this.text_search_event,
          region: this.store.state.region,
          excludeeventswithrestrictedpagecreation: true,
          eventtype: res === '' ? 'C' : '',
          beneficiaryaccountid: this.store.state.selected_charity.beneficiaryId
        }
      }
      
      this.$_eventManagementMixin_eventSearch(params_query)
        .then(response => {
          vm.data_event = response.data.Events
        })
        .then(() => {
          vm.LoadingSearch = false
        })

      this.store.commit('res_text_search_event', res)
    }
  }
}
</script>
